var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none",
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M9.94 10.797L5.774 6.631c-.18-.18-.053-.488.202-.488h4.167c.158 0 .286.128.286.286v4.166c0 .255-.309.383-.489.202z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M11.143 0H.857C.384 0 0 .384 0 .857v6.429c0 .473.384.857.857.857h10.286c.473 0 .857-.384.857-.857V.857C12 .384 11.616 0 11.143 0zm-8 4.929c-.474 0-.857-.384-.857-.858 0-.473.383-.857.857-.857.473 0 .857.384.857.857 0 .474-.384.858-.857.858zm2.857 0c-.473 0-.857-.384-.857-.858 0-.473.384-.857.857-.857s.857.384.857.857c0 .474-.384.858-.857.858zm2.857 0C8.384 4.929 8 4.545 8 4.07c0-.473.384-.857.857-.857.474 0 .857.384.857.857 0 .474-.383.858-.857.858z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6cbce7150855f0e1771ed665d49204ce.svg";
export { ForwardRef as ReactComponent };